import { withHook } from 'utils/withHook';
import { useNewsPreviewFooterState } from 'containers/NewsPreviewFooter/logic/useNewsPreviewFooterState';
import { NewsPreviewFooterView } from 'containers/NewsPreviewFooter/view/NewsPreviewFooterView';

export const NewsPreviewFooter = withHook(useNewsPreviewFooterState)(
  NewsPreviewFooterView
);
